/*
 * <card-swatches> — 商品カードのカラー画像スワッチ
 * クリックされたスワッチのバリアント画像でカードのメイン画像を差し替え、
 * カードのリンク先(タイトル/画像リンク)をそのカラーのバリアントURLへ更新する。
 *
 * ES module のため、同一 src の <script> がカードごとに複数あってもブラウザは1回だけ実行する
 * （＝定義の多重登録は起きない）。各 <card-swatches> は自身の connectedCallback で初期化される。
 */
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      connectedCallback() {
        const wrapper = this.closest('.card-wrapper');
        // 差し替え対象＝カードのメディア画像すべて。
        // PC はカードのホバー中に 1枚目(メイン)を隠して 2枚目(副画像)を表示するため、
        // 1枚目だけ差し替えるとホバー中に切り替わって見えない。両方差し替えて確実に反映する。
        this.targetImgs = wrapper ? wrapper.querySelectorAll('.card__media img') : [];
        // タイトル/画像のリンク（バリアントURLへ張り替える）
        this.links = wrapper ? wrapper.querySelectorAll('a.full-unstyled-link') : [];
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const swatch = event.target.closest('.card-swatch');
        if (!swatch || !this.contains(swatch)) return;
        event.preventDefault();

        const src = swatch.dataset.swatchSrc;
        const srcset = swatch.dataset.swatchSrcset;
        if (src && this.targetImgs.length) {
          this.targetImgs.forEach((img) => {
            // srcset を先に入れないと古い srcset が優先されて src が効かない場合がある
            img.srcset = srcset || '';
            img.src = src;
          });
        }

        this.querySelectorAll('.card-swatch[aria-current]').forEach((el) =>
          el.removeAttribute('aria-current')
        );
        swatch.setAttribute('aria-current', 'true');

        const url = swatch.dataset.variantUrl;
        if (url && this.links.length) {
          this.links.forEach((a) => a.setAttribute('href', url));
        }
      }
    }
  );
}
